import { NavigateOptions, To, useMatches, useNavigate } from "react-router-dom";
import { useModal } from "modal-react-ccs";

import { RouteObject } from "../types";

class RegisterPath {
    static _instance: RegisterPath;

    private _last: string | number = "";

    private _preventNavigation = false;

    constructor() {
        if (RegisterPath._instance) {
            return RegisterPath._instance;
        }

        this._last = "";
        this._preventNavigation = false;

        RegisterPath._instance = this;

        return RegisterPath._instance;
    }

    get last() {
        return this._last;
    }

    set last(value: string | number) {
        this._last = value;
    }

    get preventNavigation() {
        return this._preventNavigation;
    }

    set preventNavigation(value: boolean) {
        this._preventNavigation = value;
    }
}

const registerPath = new RegisterPath();

const normalizeRoutes = (matches: RouteObject[]) =>
    matches.slice(0, matches.length - 1);

export const useRoutes = () => {
    const navigate = useNavigate();
    const matches = useMatches();
    const { showQuestion } = useModal();

    const routes = normalizeRoutes(matches);

    const _navigate = (to: To, options?: NavigateOptions) => {
        if (!registerPath.preventNavigation) {
            navigate(to, options);
        } else {
            showQuestion(
                "Prevent Navigation",
                "You navigation has been blocked! Do you wish to continue?",
                () => {
                    registerPath.preventNavigation = false;

                    navigate(to, options);
                }
            );
        }
    };

    const setLastRegisterPath = (value: string | number) => {
        registerPath.last = value;
    };

    const getLastRegisterPath = () => {
        return registerPath.last;
    };

    const preventNavigation = () => {
        registerPath.preventNavigation = true;
    };

    return {
        routes,
        navigate: _navigate,
        preventNavigation,
        setLastRegisterPath,
        getLastRegisterPath,
    };
};
